import { Router, Routes, UrlTree } from '@angular/router';
import { BaseComponent } from './pages/layout/website/base/base.component';
import { AUTH_PATH, PROFILE, PLUS_MEMBERSHIP, WOW_SSO, HEALTH_SHARING, VISION_SERVICE, OFFICE_VISIT, SURGICAL, IMAGING, REQUEST_IMAGING_APPOINTMENT, REQUEST_SURGICAL_APPOINTMENT, VIRTUAL_URGENT_CARE, ALL_SERVICES, HEALTHSHARE_SERVICE, ADVOCATES, PHARMACY, PHARMACY_LIST, BRANDED_MEDICINES_REQUEST, PHARMACY_BRAND_DETAILS, TRANSFER, MENTAL_HEALTH_COUNSELING, LAB_TEST, CONTACT_US, WOW_VIDEO, ABOUT_US, FAQS, DENTAL, DENTAL_PROCEDURE, CANCEL, SUCCESS, PROFILE_COMPLETION, PAYMENT, COMPREHENSIVE_SELECTION, EMPLOYERS, EMPLOYERS_QUOTATION, CHANGE_PLAN, MARKETING_PRESELL_PAGE, ADD_PROFILE_CARD, FIND_A_DENTIST, PROFESSIONALS, VERIFY_PROFILE, PROFESSIONAL_BOOKED_APPOINTMENT, APPOINTMENT_BOOKED_DETAIL, RESOURCES, EINSTEIN, WHATA_BURGER, PERFECTPIZZAPIE, FAZOLI, PARKER_HOSPITALITY, HUB_INTERNATIONAL, AQUORAL, SCRIPT_SAVER, AMAC, JETS_PIZZA, PRESTIGE, CEHAS, HRA_SURVEY, ACA_CONTENT, ACAWELLNESS, CEHAS_ACCESS_ACCOUNT, BUY_MEMBERSHIP, TRU, TRU_ACCESS_ACCOUNT, PROVIDER_APPOINTMENT_CONFIRMATION, LOGIN_PATH, RESET_PASSWORD_PATH, FORGOT_PASSWORD_PATH, CREAT_PASSWORD_PATH, SSO, ARS, REQ_CONSULTING_BASIC, REQ_CONSULTING_PLUS, IAC, JOIN_AS_AGENCY, SSO_USER, OUR_POLICY, APP_PRIVACY_POLICY, PHARMACY_LIST_WP, SUBMIT_REIMBURSEMENT_CLAIM, IMPERSONATE } from './core/constants';
import { preventAuthGuard, AuthorizationGuard } from './core/guards';
import { verifyprofileguardGuard } from './core/guards/verifyprofileguard.guard';
import { MiniEnvResolver } from './core/resolvers/mini-env.resolver';
import { TranslationDataService } from './core/services/translation-data.service';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { PdfLayoutComponent } from './pages/pdf-layout/pdf-layout.component';
import { PurchaseRedirectGuard } from './core/guards/purchase-redirect.guard';
import { SSPComponent } from './pages/mini-env/ssp/ssp.component';
import { ACAWellnessComponent } from '@views/mini-env/aca-wellness/aca-wellness.component';
import { EinsteinComponent } from '@views/mini-env/einstein/einstein.component';
import { WhatABurgerComponent } from '@views/mini-env/what-a-burger/what-a-burger.component';
import { PerfectpizzapieComponent } from '@views/mini-env/perfectpizzapie/perfectpizzapie.component';
import { FazoliComponent } from '@views/mini-env/fazoli/fazoli.component';
import { HubInternationalComponent } from '@src/app/pages/mini-env/hub-international/hub-international.component';
import { AMACComponent } from '@src/app/pages/mini-env/amac/amac.component';
import { ParkerHospitalityComponent } from '@views/mini-env/parker-hospitality/parker-hospitality.component';
import { AquoralComponent } from '@views/mini-env/aquoral/aquoral.component';
import { JetsPizzaComponent } from '@views/mini-env/jets-pizza/jets-pizza.component';
import { PrestigeComponent } from '@views/mini-env/prestige/prestige.component';
import { CehasComponent } from '@views/mini-env/cehas/cehas.component';
import { TruComponent } from '@views/mini-env/tru/tru.component';
import { ReqConsultingComponent } from './pages/mini-env/req-consulting/req-consulting.component';
import { ArsComponent } from './pages/mini-env/ars/ars.component';
import { inject } from '@angular/core';
import { legacyRedirectGuard } from './core/guards/legacy-redirect.guard';
import { IacComponent } from './pages/mini-env/iac/iac.component';
import { SeoResolver } from './core/resolvers/seo.resolver';
import { ImpersonateComponent } from './pages/impersonate/impersonate.component';


export const routes: Routes = [
  {
    canActivate: [preventAuthGuard],
    path: AUTH_PATH,
    loadChildren: () => import('@views/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: PROFILE,
    canActivate: [AuthorizationGuard],
    loadChildren: () => import('@src/app/pages/layout/member-portal/memberportal.module').then(x => x.MemberPortalModule),
  },
  {
    path: '',
    component: BaseComponent,
    children: [
      // {
      //   canActivate: [AuthorizationGuard],
      //   path: DASHBOARD,
      //   loadComponent: () =>
      //     import('@views/dashboard/dashboard.component').then(
      //       m => m.DashboardComponent,
      //     ),
      // },   

      {
        path: 'error',
        component: ErrorPageComponent,
        data: {
          type: 404,
          title: 'Oops! This page is missing',
          desc: "Looks like you’ve taken a wrong turn. The page you’re looking for doesn’t exist.",
        },
      },
      {
        path: 'sign-in',
        redirectTo: `/${LOGIN_PATH}`,
        pathMatch: 'full'
      },
      {
        path: 'reset-password',
        redirectTo: (snapshot): string | UrlTree => {
          const router = inject(Router);
          return router.createUrlTree([`/${RESET_PASSWORD_PATH}`], {
            queryParams: snapshot.queryParams,
          });
        },
        pathMatch: 'full'
      },
      {
        path: 'forgot-password',
        redirectTo: `/${FORGOT_PASSWORD_PATH}`,
        pathMatch: 'full'
      },
      {
        path: 'access-account',
        redirectTo: `/${CREAT_PASSWORD_PATH}`,
        pathMatch: 'full'
      },
      {
        path: '',
        loadComponent: () =>
          import('@views/home/home.component').then(m => m.HomeComponent),
        title: 'Affordable Low-Cost Healthcare Plans & Memberships - WoW Health',
        data: { metaTitle: 'HOME', metaDescription: 'HOME Description', languageFilePath: "assets/i18n/home/" },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PLUS_MEMBERSHIP,
        canActivate: [PurchaseRedirectGuard],
        loadComponent: () =>
          import('@views/everydaycare/everydaycare.component').then(
            m => m.EverydayCareComponent,
          ),
        title: 'WoW Plus Membership - Cheaper Healthcare Plans - WoW Health',
        data: { metaTitle: 'PlusMembership', metaDescription: 'Plus Membership', languageFilePath: "assets/i18n/everydaycare/", isSubDomain: false },
        resolve: { TranslationDataService, SeoResolver }
      },
      {

        path: WOW_SSO,
        loadComponent: () =>
          import('@views/profile/sso-page/sso-page.component').then(
            m => m.SsoCallbackComponent,
          ),

        // resolve: { TranslationDataService }
      },
      {
        path: HEALTH_SHARING,
        loadComponent: () =>
          import('@views/health-sharing/health-sharing.component').then(
            m => m.HealthSharingComponent,
          ),
        title: 'Best HealthShare Plans - HealthSharing Options - WoW Health',
        data: {
          metaTitle: 'HealthSharing - Best HealthShare Plans - WoW Health',
          metaDescription: 'Health Sharing', languageFilePath: "assets/i18n/health-sharing/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      //   {
      //     path: USER_MANGEMENT,
      //     loadChildren: () => import('./features').then(m => m.UserManagementModule),
      //   },
      {
        path: VISION_SERVICE,
        loadComponent: () =>
          import('@views/vision-care/vision-care.component').then(
            m => m.VisionCareComponent,
          ),
        data: {
          languageFilePath: "assets/i18n/vision-care/"
        },
        title: 'Best Vision Care Services - Clearer Vision Awaits - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: OFFICE_VISIT,
        loadComponent: () =>
          import('@views/office-visit/office-visit.component').then(
            x => x.OfficeVisitComponent,
          ),
        title: 'In-Person Visit To Doctor\'s Office - Find Doctor Near You',
        data: { metaTitle: 'OfficeVisit', metaDescription: 'Office Visit', languageFilePath: "assets/i18n/office-visit/" },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: SURGICAL,
        loadComponent: () =>
          import('@views/surgical/surgical.component').then(
            x => x.SurgicalComponent,
          ),
        title: 'Book Appointments for Surgery/Surgical Treatments - WoW Health',
        data: {
          languageFilePath: "assets/i18n/surgical/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },

      {
        path: IMAGING,
        loadComponent: () =>
          import('@views/imaging/imaging.component').then(
            x => x.ImagingComponent,
          ),
        title: 'Discounts on Imaging Tests like CT Scans, MRI, Ultrasound - WoW Health',
        data: {
          languageFilePath: "assets/i18n/imaging/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: REQUEST_IMAGING_APPOINTMENT,
        loadComponent: () =>
          import('@views/request-imaging-appointment/request-imaging-appointment.component').then(
            x => x.RequestImagingAppointmentComponent,
          ),
        title: 'Request Imaging Appointment - WoW Health',
        data: {
          languageFilePath: "assets/i18n/imaging/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: REQUEST_SURGICAL_APPOINTMENT,
        loadComponent: () =>
          import('@views/request-surgical-appointment/request-surgical-appointment.component').then(
            x => x.RequestSurgicalAppointmentComponent,
          ),
        title: 'Request Surgical Appointment - WoW Health',
        data: {
          languageFilePath: "assets/i18n/surgical/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: VIRTUAL_URGENT_CARE,
        loadComponent: () =>
          import('@views/virtual-urgent-care/virtual-urgent-care.component').then(
            x => x.VirtualUrgentCareComponent,
          ),
        title: 'Virtual Urgent Care - 24/7 Virtual Care For You - WoW Health',
        data: {
          languageFilePath: "assets/i18n/virtual-urgent-care/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: ALL_SERVICES,
        loadComponent: () =>
          import('@views/all-services/all-services.component').then(
            x => x.AllServicesComponent,
          ),
        title: 'All Services - WoW Health',
        data: {
          languageFilePath: "assets/i18n/all-services/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: HEALTHSHARE_SERVICE,
        loadComponent: () =>
          import(
            '@views/healthshare-services/healthshare-services.component'
          ).then(x => x.HealthshareServicesComponent),
        title: 'HealthSharing Reimbursement - WoW Health',
        data: {
          languageFilePath: "assets/i18n/healthshare-service/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: ADVOCATES,
        loadComponent: () =>
          import('@views/brokers/brokers.component').then(x => x.BrokersComponent),
        title: 'Become the Agents of Change - WoW Health',
        data: {
          languageFilePath: "assets/i18n/brokers/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PHARMACY,
        loadComponent: () =>
          import('@views/pharmacy/pharmacy.component').then(
            x => x.PharmacyComponent,
          ),
        title: 'Get Discounted Medicines From Your Nearest Pharmacies - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PHARMACY_LIST,
        loadComponent: () =>
          import('@views/pharmacies-list/pharmacies-list.component').then(
            x => x.PharmaciesListComponent,
          ),
        title: 'Pharmacies List - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: BRANDED_MEDICINES_REQUEST,
        loadComponent: () =>
          import('@views/branded-medicine-request/branded-medicine-request.component').then(
            x => x.BrandedMedicineRequestPage,
          ),
        title: 'Branded Medicine Request - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PHARMACY_BRAND_DETAILS,
        loadComponent: () =>
          import('@views/pharmacy-brand-detail/pharmacy-brand-detail.component').then(
            x => x.PharmacyBrandDetailComponent,
          ),
        title: 'Pharmacy Brand Details - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: TRANSFER,
        loadComponent: () =>
          import('@views/transfer/transfer.component').then(
            x => x.TransferComponent,
          ),
        title: 'Transfer Medicine - WoW Health',
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: MENTAL_HEALTH_COUNSELING,
        loadComponent: () =>
          import(
            '@views/mental-health-counselling/mental-health-counselling.component'
          ).then(x => x.MentalHealthCounsellingComponent),
        title: 'Mental Health Counseling: Improve Your Well-Being - WoW Health',
        data: {
          languageFilePath: "assets/i18n/mental-health-counselling/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: LAB_TEST,
        loadComponent: () =>
          import('@views/lab-tests/lab-tests.component').then(
            x => x.LabTestsComponent,
          ),
        title: 'Find Lab Tests Online - Easy & Affordable - WoW Health',
        data: {
          languageFilePath: "assets/i18n/lab-test/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: CONTACT_US,
        loadComponent: () =>
          import('@views/contact-us/contact-us.component').then(x => x.ContactUsComponent),
        title: 'Contact Us - WoW Health',
        data: {
          languageFilePath: "assets/i18n/contact-us/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: OUR_POLICY,
        loadComponent: () =>
          import('@views/our-policy/our-policy.component').then(x => x.OurPolicyComponent),
        title: 'Our Policy - WoW Health',
        data: {
          languageFilePath: "assets/i18n/our-policy/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: WOW_VIDEO,
        loadComponent: () =>
          import('@views/wow-video/wow-video.component').then(x => x.WowVideoComponent),
        title: 'Resources - WoW Health',
        data: {
          languageFilePath: "assets/i18n/wow-video/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: ABOUT_US,
        loadComponent: () =>
          import('@views/about-us/about-us.component').then(x => x.AboutUsComponent),
        title: 'Get To Know About Us - WoW Health',
        data: {
          languageFilePath: "assets/i18n/about-us/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: FAQS,
        loadComponent: () => import('@views/faqs/faqs.component').then(x => x.FaqsComponent),
        title: 'Resources - WoW Health',
        data: {
          languageFilePath: "assets/i18n/faqs/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: DENTAL,
        loadComponent: () =>
          import('@views/dental/dental.component').then(x => x.DentalComponent),
        title: 'Simple Solutions for all Your Dental Problems - WoW Health',
        data: {
          languageFilePath: "assets/i18n/dental/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: DENTAL_PROCEDURE,
        loadComponent: () => import('@views/dental-procedure/dental-procedure.component').then(x => x.DentalProcedureComponent),
        data: {
          languageFilePath: "assets/i18n/dental-procedure/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: CANCEL,
        loadComponent: () =>
          import('@views/profile/membership/cancel-membership/cancel-membership.component').then(x => x.CancelMembershipComponent),
        title: 'Cancel Membership - WoW Health',
        data: {
          languageFilePath: "assets/i18n/membership/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: SUCCESS,
        loadComponent: () =>
          import('./core/shared/components/success/success.component').then(x => x.SuccessComponent),
        data: {
          languageFilePath: "assets/i18n/membership/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      // {
      //   path: PROFILE,
      //   canActivate: [AuthorizationGuard],
      //   loadChildren: () => import('@views/profile/profile.module').then(x => x.ProfileModule),
      // },
      {
        path: SUBMIT_REIMBURSEMENT_CLAIM,
        canActivate: [AuthorizationGuard],
        title: 'Submit Reimbursement Claim - WoW Health',
        data: { languageFilePath: 'assets/i18n/submit-reimbursement-claim/' },
        loadComponent: () =>
          import('@views/submit-reimbursement-claim/submit-reimbursement-claim.component').then(
            x => x.SubmitReimbursementClaimComponent,
          ),
        resolve: { TranslationDataService }
      },
      {
        path: PROFILE_COMPLETION + "/:id",
        canActivate: [AuthorizationGuard],
        title: 'Update Information - WoW Health',
        loadComponent: () =>
          import('@views/profile-completion/profile-completion.component').then(x => x.ProfileCompletionComponent)
      },
      {
        path: PROFILE_COMPLETION,
        canActivate: [AuthorizationGuard],
        title: 'Update Information - WoW Health',
        loadComponent: () =>
          import('@views/profile-completion/profile-completion.component').then(x => x.ProfileCompletionComponent)
      },
      {
        path: PAYMENT,
        canActivate: [],
        loadComponent: () =>
          import('@views/payment/payment.component').then(x => x.PaymentComponent),
        title: 'Finalize Appointment - WoW Health',
        data: {
          languageFilePath: "assets/i18n/payment/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: COMPREHENSIVE_SELECTION,
        loadComponent: () =>
          import('@views/membership-payment/membership-payment.component').then(x => x.MembershipPaymentComponent),
        data: {
          languageFilePath: "assets/i18n/payment/"
        },
        title: 'HealthShare Selection - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: EMPLOYERS,
        loadComponent: () =>
          import('@views/employer-benefits/employer-benefits.component').then(x => x.EmployerBenefitsComponent),
        data: {
          languageFilePath: "assets/i18n/employer-benefits/"
        },
        title: 'Employer Benefits - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: EMPLOYERS_QUOTATION,
        loadComponent: () =>
          import('@views/employer-quotation/employer-quotation.component').then(x => x.EmployerQuotationComponent),
        title: 'Employer Quotation - WoW Health',
        data: {
          languageFilePath: "assets/i18n/employer-quotation/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },

      {
        path: BUY_MEMBERSHIP,
        canActivate: [PurchaseRedirectGuard],
        loadComponent: () =>
          import('@views/buy-membership/buy-membership.component').then(x => x.BuyMembershipComponent),
        data: {
          languageFilePath: "assets/i18n/everydaycare/"
        },
        title: 'Buy WoW Plus Membership - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: CHANGE_PLAN,
        loadComponent: () =>
          import('@views/change-plan/change-plan.component').then(x => x.ChangePlanComponent),
        data: {
          languageFilePath: "assets/i18n/everydaycare/"
        },
        title: 'Change Plan - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: MARKETING_PRESELL_PAGE,
        loadComponent: () =>
          import('@src/app/pages/marketing/dm-marketing/presell-page/presell-page.component').then(x => x.PresellPageComponent),
        title: 'Presell Page - WoW Health',
        data: {
          languageFilePath: "assets/i18n/marketing/dm-marketing/presell-page/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      //   {
      //     path: 'add-funds',
      //     loadComponent: () =>
      //       import('./features/payment/payment.component').then(x => x.PaymentComponent),
      //   },
      {
        path: ADD_PROFILE_CARD,
        loadComponent: () =>
          import('@views/payment/views/add-card-screen/add-card-screen.component').then(x => x.AddCardScreenComponent),
        title: 'Add Profile Card - WoW Health',
      },
      //   {
      //     path: 'choose-your-path-to-expert-advice',
      //     loadComponent: () =>
      //       import('./features/choose-your-path/choose-your-path.component').then(x => x.ChooseYourPathComponent),
      //   },
      {

        canActivate: [AuthorizationGuard],
        path: ACA_CONTENT,
        loadComponent: () =>
          import('@views/wellness-stats-listing/wellness-stats-listing.component').then(x => x.WellnessStatsListingComponent),
        data: {
          languageFilePath: "assets/i18n/aca-stats-listing/"
        },
        title: 'ACA Content - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: FIND_A_DENTIST,
        loadComponent: () =>
          import('@views/find-a-dentist/find-a-dentist.component').then(x => x.FindADentistComponent),
        data: {
          languageFilePath: "assets/i18n/find-a-dentist/"
        },
        title: 'Find a Dentist - WoW Health',
        resolve: { TranslationDataService, SeoResolver }
        // canActivate: [AuthorizationGuard]
      },
      {
        path: PROFESSIONALS,
        loadComponent: () =>
          import('@views/find-a-professional/find-a-professional.component').then(x => x.FindAProfessionalComponent),
        title: 'Find a Professional - WoW Health',
        // canActivate: [AuthorizationGuard]
      },
      {
        path: VERIFY_PROFILE,
        loadComponent: () =>
          import('@views/verify-profile/verify-profile.component').then(x => x.VerifyProfileComponent),
        title: 'Verify Profile - WoW Health',
        data: {
          languageFilePath: "assets/i18n/verify-profile/"
        },
        resolve: { TranslationDataService, SeoResolver },
        canActivate: [verifyprofileguardGuard]
      },
      //   {
      //     path: VISION_PROVIDERS,
      //     loadComponent: () =>
      //       import('./features/members/views/vision-providers/vision-providers.component').then(x => x.VisionProvidersComponent),
      //   },
      //   {
      //     path: 'medicine-on-request',
      //     loadComponent: () =>
      //       import('./features/medicine-on-request/medicine-on-request.component').then(x => x.MedicineOnRequestComponent),
      //     data: {
      //       languageFilePath: "assets/i18n/medicine-on-request/"
      //     },
      //     resolve: { TranslationDataService }
      //   },
      //   {
      //     path: RESOLVER,
      //     loadComponent: () =>
      //       import('./features/resolver/resolver.component').then(x => x.ResolverComponent),
      //   },
      //   {
      //     path: 'patient-advocacy-line-service',
      //     loadComponent: () =>
      //       import('./features/patient-advocacy/patient-advocacy.component').then(x => x.PatientAdvocacyComponent),
      //   },
      //   {
      //     path: 'professionals',
      //     loadComponent: () =>
      //       import('./features/professionals/professionals.component').then(x => x.ProfessionalsComponent),
      //   },
      {
        path: 'professionals-detail',
        loadComponent: () =>
          import('@views/professionals-detail/professionals-detail.component').then(x => x.ProfessionalsDetailComponent),
        data: {
          languageFilePath: "assets/i18n/professionals-detail-checkout/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PROFESSIONAL_BOOKED_APPOINTMENT,
        loadComponent: () =>
          import('@views/appointment-checkout/appointment-checkout.component').then(x => x.AppointmentCheckoutComponent),
        title: 'Appointment Checkout - WoW Health',
        data: {
          languageFilePath: "assets/i18n/appointment-checkout/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: APPOINTMENT_BOOKED_DETAIL,
        loadComponent: () =>
          import('@views/membership-card-contact-detail/membership-card-contact-detail.component').then(x => x.MembershipCardContactDetailComponent),
        title: 'Appointment Detail - WoW Health',
        data: {
          languageFilePath: "assets/i18n/appointment-checkout/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: PROVIDER_APPOINTMENT_CONFIRMATION,
        loadComponent: () =>
          import('@views/provider-appointment-confirmation/provider-appointment-confirmation.component').then(x => x.ProviderAppointmentConfirmationComponent),
        title: 'Provider Appointment Confirmation - WoW Health',
        data: {
          languageFilePath: "assets/i18n/provider-appointment-confirmation/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: RESOURCES,
        loadComponent: () =>
          import('@views/resources/resources.component').then(x => x.ResourcesComponent),
        title: 'Resources - WoW Health',
        data: {
          languageFilePath: "assets/i18n/resources/"
        },
        resolve: { TranslationDataService, SeoResolver }
      },
      //   {
      //     path: 'blogs',
      //     loadComponent: () =>
      //       import('./features/blogs/blogs.component').then(x => x.BlogsComponent),
      //   },
      //   {
      //     path: 'blog/detail',
      //     loadComponent: () =>
      //       import('./features/blogs/blog-detail/blog-detail.component').then(x => x.BlogDetailComponent),
      //   },
      //   { path: '', redirectTo: '', pathMatch: 'full' },
      //   {
      //     path: 'appointment-confirmation',
      //     loadComponent: () =>
      //       import('./features/appointment-details/appointment-details.component').then(x => x.AppointmentDetailsComponent),
      //   },
      {
        path: 'manage-payment-methods',
        loadComponent: () =>
          import('@views/profile/membership/manage-payment-methods/manage-payment-methods.component').then(x => x.ManagePaymentMethodsComponent),
        data: {
          languageFilePath: "assets/i18n/",
          title: 'Manage Payment Methods - WoW Health'
        },
        resolve: { TranslationDataService, SeoResolver }
        //   data: {
        //   languageFilePath: "assets/i18n"
        // },
      },
      {
        path: ACAWELLNESS,
        data: { metaTitle: 'ACAWELLNESS', metaDescription: 'ACAWELLNESS Description', languageFilePath: "assets/i18n/mini-env/acawellness/" },
        title: 'ACA Wellness - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: ACAWellnessComponent
          }
        ]
      },
      {
        path: EINSTEIN,
        data: { metaTitle: 'EINSTEIN', metaDescription: 'EINSTEIN Description', languageFilePath: "assets/i18n/mini-env/einstein/" },
        title: 'Einstein - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: EinsteinComponent
          }
        ]
      },
      {
        path: WHATA_BURGER,
        data: { metaTitle: 'WHATA_BURGER', metaDescription: 'WHATA_BURGER Description', languageFilePath: "assets/i18n/mini-env/whataburger/" },
        title: 'What a Burger - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: WhatABurgerComponent
          }
        ]
      },
      {
        path: PERFECTPIZZAPIE,
        data: { metaTitle: 'PERFECTPIZZAPIE', metaDescription: 'PERFECTPIZZAPIE Description', languageFilePath: "assets/i18n/mini-env/perfectpizzapie/" },
        title: 'Perfect Pizza Pie - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: PerfectpizzapieComponent
          }
        ]
      },
      {
        path: FAZOLI,
        data: { metaTitle: 'FAZOLI', metaDescription: 'FAZOLI Description', languageFilePath: "assets/i18n/mini-env/fazoli/" },
        title: 'Fazoli - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: FazoliComponent
          }
        ]
      },
      {
        path: HUB_INTERNATIONAL,
        data: { metaTitle: 'Hub International', metaDescription: 'Hub International Description', languageFilePath: "assets/i18n/mini-env/hub-international/" },
        title: 'Hub International - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: HubInternationalComponent
          }
        ]
      },
      {
        path: SCRIPT_SAVER,
        data: { metaTitle: 'Script Saver', metaDescription: 'Script Saver Description', languageFilePath: "assets/i18n/mini-env/ssp/" },
        title: 'Script Saver - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: SSPComponent
          }
        ]
      },
      {
        path: AMAC,
        data: { metaTitle: 'amac', metaDescription: 'amac Description', languageFilePath: "assets/i18n/mini-env/amac/" },
        title: 'AMAC - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: AMACComponent
          }
        ]
      },
      {
        path: PARKER_HOSPITALITY,
        data: { metaTitle: 'PARKER', metaDescription: 'PARKER Description', languageFilePath: "assets/i18n/mini-env/fazoli/" },
        title: 'Parker Hospitality - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: ParkerHospitalityComponent
          }
        ]
      },
      {
        path: ARS,
        data: { metaTitle: 'ars', metaDescription: 'ars Description', languageFilePath: "assets/i18n/mini-env/ars/" },
        title: 'ARS - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: ArsComponent
          }
        ]
      },
      {
        path: AQUORAL,
        data: { metaTitle: 'AQUORAL', metaDescription: 'AQUORAL Description', languageFilePath: "assets/i18n/mini-env/aquoral/" },
        title: 'Aquoral - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: AquoralComponent
          }
        ]
      },
      {
        path: JETS_PIZZA,
        data: { metaTitle: 'JETS PIZZA', metaDescription: 'JETS PIZZA Description', languageFilePath: "assets/i18n/mini-env/jets-pizza/" },
        title: 'Jets Pizza - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: JetsPizzaComponent
          }
        ]
      },
      {
        path: PRESTIGE,
        data: { metaTitle: 'PRESTIGE', metaDescription: 'PRESTIGE Description', languageFilePath: "assets/i18n/mini-env/prestige/" },
        title: 'Prestige - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: PrestigeComponent
          }
        ]
      },
      {
        path: CEHAS,
        data: { metaTitle: 'CEHAS', metaDescription: 'CEHAS Description', languageFilePath: "assets/i18n/mini-env/cehas/" },
        title: 'CEHAS - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: CehasComponent
          }
        ]
      },
      {
        path: CEHAS_ACCESS_ACCOUNT,
        loadComponent: () =>
          import('@views/auth/access-account/creat.component').then(m => m.CreatComponent),
        title: 'CEHAS - WoW Health',
        data: { metaTitle: 'CEHAS', metaDescription: 'CEHAS Description', languageFilePath: "assets/i18n/mini-env/cehas/cehas-account-activate/" },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: TRU,
        data: { metaTitle: 'TRU', metaDescription: 'TRU Description', languageFilePath: "assets/i18n/mini-env/tru/" },
        title: 'TRU - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: TruComponent
          }
        ]
      },
      {
        path: TRU_ACCESS_ACCOUNT,
        loadComponent: () =>
          import('@views/auth/access-account/creat.component').then(m => m.CreatComponent),
        title: 'TRU ACCESS ACCOUNT- WoW Health',
        data: { metaTitle: 'TRU', metaDescription: 'TRU Description', languageFilePath: "assets/i18n/mini-env/tru/tru-account-activate/" },
        resolve: { TranslationDataService, SeoResolver }
      },
      {
        path: REQ_CONSULTING_BASIC,
        data: { metaTitle: 'Req Consulting Basic', metaDescription: 'Req Consulting Basic Description', languageFilePath: "assets/i18n/mini-env/req-consulting/" },
        title: 'Req Consulting Basic - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: ReqConsultingComponent
          }
        ]
      },
      {
        path: REQ_CONSULTING_PLUS,
        data: { metaTitle: 'Req Consulting Plus', metaDescription: 'Req Consulting Plus Description', languageFilePath: "assets/i18n/mini-env/req-consulting/" },
        title: 'Req Consulting Plus - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: ReqConsultingComponent
          }
        ]
      },
      {
        path: IAC,
        data: { metaTitle: 'IAC', metaDescription: 'IAC Description', languageFilePath: "assets/i18n/mini-env/iac/" },
        title: 'IAC - WoW Health',
        resolve: { TranslationDataService, SeoResolver, MiniEnvResolver },
        children: [
          {
            path: "**",
            component: IacComponent
          }
        ]
      },
      {
        path: PHARMACY_LIST_WP,
        loadComponent: () =>
          import('@views/pharmacies-list/pharmacies-list.component').then(
            x => x.PharmaciesListComponent,
          ),
        data: {
          languageFilePath: "assets/i18n/pharmacy/"
        },
        resolve: { TranslationDataService }
      },
      { path: '', redirectTo: '', pathMatch: 'full' },
      // { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ],
  },
  //   {
  //     path: 'provider-appointment-confirmation',
  //     loadComponent: () =>
  //       import('./features/provider-appointment-confirmation/provider-appointment-confirmation.component').then(x => x.ProviderAppointmentConfirmationComponent),
  //   },


  {
    path: 'pdf',
    component: PdfLayoutComponent,
    children: [
      {
        path: "pharmacy-card-pdf",
        loadComponent: () =>
          import('@views/pdf-pages/pharmacy-card-pdf/pharmacy-card-pdf.component').then(
            m => m.PharmacyCardPdfComponent,
          ),
      },
    ]
  },
  {
    path: HRA_SURVEY,
    loadComponent: () =>
      import('@views/hra-survey/hra-survey.component').then(x => x.HraSurveyComponent),
    title: 'HRA Survey',
    data: {
      languageFilePath: "assets/i18n/hra-survey/"
    },
    resolve: { TranslationDataService, SeoResolver }
    //   data: {
    //   languageFilePath: "assets/i18n"
    // },
  },
  {
    path: SSO,
    loadComponent: () =>
      import('@views/sso/sso.component').then(
        x => x.SSOComponent
      )
  },
  {
    path: SSO_USER,
    loadComponent: () =>
      import('@views/sso-user/sso-user.component').then(
        x => x.SSOUserComponent
      )
  },
  {
    path: APP_PRIVACY_POLICY,
    loadComponent: () =>
      import('@views/app-privacy-policy/app-privacy-policy.component').then(x => x.AppPrivacyPolicyComponent),
    data: { metaTitle: 'Privacy Policy', metaDescription: 'WoW Health Privacy Policy' }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent,
  },
  {
    path: JOIN_AS_AGENCY,
    canActivate: [],
    title: 'Join as an Agency - WoW Health',
    loadComponent: () => import('@views/iac-collaboration/iac-collaboration.component').then(x => x.IacCollaborationComponent)
  },
  {
    path: IMPERSONATE,
    canActivate: [],
    title: 'Impersonate patient',
    component: ImpersonateComponent
  },
  {
    path: ':slug',
    canActivate: [legacyRedirectGuard],
    loadComponent: () => import('@angular/core').then(({ Component }) =>
      Component({
        selector: 'app-legacy-redirect',
        template: '',
        standalone: true
      })(class { })
    )
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];
